import * as React from "react";
const SvgTriangleUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.7998 10.8H13.1998L8.9998 5.40002L4.7998 10.8Z", fill: "currentColor" }));
export default SvgTriangleUp;
